import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'

import { ReactComponent as CloseFilled } from '../assets/icons/close-filled.svg'
import { ReactComponent as CheckMark } from '../assets/icons/checkmark.svg'
import { ReactComponent as DownArrow } from '../assets/icons/chevron-down.svg'
import {
  getSessionsAvailableDay,
  getSessionsAvailablePeriod,
  getSessionsAvailableWeeks,
  postSessions,
} from '../apis/session.ts'
import { dayEnumList } from '../assets/data.js'

export default function SessionAddCard({ semesterId, courseId, onStateChange }) {
  /*************** react-hook-form **************/
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    getFieldState,
    resetField,
    formState: { isValid },
  } = useForm({
    defaultValues: {
      courseId: courseId,
      dayOfWeek: '',
      period: '',
    },
  })

  /*************** useEffect **************/
  useEffect(() => {
    getSessionsAvailableWeeksApi()
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    if (watch('week')) {
      getSessionsAvailableDayApi(watch('week'))
    }
    // eslint-disable-next-line
  }, [watch('week')])

  useEffect(() => {
    if (watch('dayOfWeek')) {
      getSessionsAvailablePeriodApi(watch('week'), watch('dayOfWeek'))
    }
    // eslint-disable-next-line
  }, [watch('dayOfWeek')])

  useEffect(() => {
    resetField('dayOfWeek')
    resetField('period')
    // eslint-disable-next-line
  }, [watch('week')])

  /*************** 가능한 주차 조회 API **************/
  const [availableWeeks, setAvailableWeeks] = useState()
  const getSessionsAvailableWeeksApi = async () => {
    const getSessionsAvailableWeeksResponse = await getSessionsAvailableWeeks({
      semesterId: semesterId,
    })

    if (getSessionsAvailableWeeksResponse.error) {
      console.log(getSessionsAvailableWeeksResponse)
      return
    } else {
      // console.log(getSessionsAvailableWeeksResponse.data)
      setAvailableWeeks(getSessionsAvailableWeeksResponse.data)
    }
  }

  /*************** 가능한 요일 조회 API **************/
  const [availableDay, setAvailableDay] = useState()
  const getSessionsAvailableDayApi = async (week) => {
    const getSessionsAvailableDayResponse = await getSessionsAvailableDay({
      semesterId: semesterId,
      week: week,
    })

    if (getSessionsAvailableDayResponse.error) {
      console.log(getSessionsAvailableDayResponse)
      return
    } else {
      // console.log(getSessionsAvailableDayResponse.data)
      setAvailableDay(getSessionsAvailableDayResponse.data)
    }
  }

  /*************** 가능한 교시 조회 API **************/
  const [availablePeriod, setAvailablePeriod] = useState()
  const getSessionsAvailablePeriodApi = async (week, day) => {
    const getSessionsAvailablePeriodResponse = await getSessionsAvailablePeriod({
      courseId: courseId,
      week: week,
      day: day,
    })

    if (getSessionsAvailablePeriodResponse.error) {
      console.log(getSessionsAvailablePeriodResponse)
      return
    } else {
      // console.log(getSessionsAvailablePeriodResponse.data)
      setAvailablePeriod(getSessionsAvailablePeriodResponse.data)
    }
  }

  /*************** 차시 생성 API **************/
  const onSubmit = async (data) => {
    console.log(data)
    const postSessionsResponse = await postSessions({
      description: data.description,
      week: data.week,
      dayOfWeek: data.dayOfWeek,
      period: data.period,
      courseId: courseId,
    })
    if (postSessionsResponse.error) {
      console.log(postSessionsResponse.message)
      return
    } else {
      console.log(postSessionsResponse.result)
      onStateChange()
    }
  }
  // console.log(watch())
  // console.log(isSubmitSuccessful)

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className='border_default mb-40 flex min-h-[90px] w-full items-center justify-between rounded-16 border-border-strong bg-background-alternative px-20 py-16'>
        <div className='flex items-center gap-32'>
          <p className='border-r-[1px] border-solid border-border-default pr-12 text-body2-semibold text-primary-normal'>
            추가
          </p>
          <div className='flex items-center gap-20'>
            <div className='flex items-center gap-[14px]'>
              <p className='shrink-0 text-body3-medium text-label-default'>주차</p>
              <div className='relative min-w-[82px]'>
                <select
                  // name='subject'
                  {...register('week', { required: true })}
                  className={`select_sm w-full default:text-label-disable ${getFieldState('week').isDirty ? '' : 'text-label-placeholder'}`}
                >
                  <option disabled selected value=''>
                    주차
                  </option>
                  {availableWeeks?.map((weekItem, weekIndex) => (
                    <option key={weekIndex} value={weekItem}>
                      {weekItem}
                    </option>
                  ))}
                </select>
                <DownArrow className='pointer-events-none absolute right-16 top-8 cursor-pointer fill-label-default' />
              </div>
              <div className='flex items-center gap-[14px]'>
                <p className='shrink-0 text-body3-medium text-label-default'>요일</p>
                <div className='relative min-w-[82px]'>
                  <select
                    {...register('dayOfWeek', { required: true })}
                    className={`select_sm peer w-full default:text-label-disable ${getFieldState('dayOfWeek').isDirty ? '' : 'text-label-placeholder'}`}
                    disabled={!getFieldState('week').isDirty}
                  >
                    <option disabled selected value=''>
                      요일
                    </option>
                    {availableDay?.map((dayItem, dayIndex) => (
                      <option key={dayIndex} value={dayItem}>
                        {dayEnumList[dayItem]}
                      </option>
                    ))}
                  </select>
                  <DownArrow className='pointer-events-none absolute right-16 top-8 cursor-pointer fill-label-default peer-disabled:fill-label-disable' />
                </div>
              </div>
              <div className='flex items-center gap-[14px]'>
                <p className='shrink-0 text-body3-medium text-label-default'>교시</p>
                <div className='relative min-w-[82px]'>
                  <select
                    {...register('period', { required: true })}
                    className={`select_sm peer w-full default:text-label-disable ${getFieldState('period').isDirty ? '' : 'text-label-placeholder'}`}
                    disabled={
                      !(getFieldState('week').isDirty && getFieldState('dayOfWeek').isDirty)
                    }
                  >
                    <option disabled selected value=''>
                      교시
                    </option>
                    {availablePeriod?.map((periodItem, periodIndex) => (
                      <option key={periodIndex} value={periodItem}>
                        {periodItem}
                      </option>
                    ))}
                  </select>
                  <DownArrow className='pointer-events-none absolute right-16 top-8 cursor-pointer fill-label-default peer-disabled:fill-label-disable' />
                </div>
              </div>
              <div className='flex items-center gap-[14px]'>
                <p className='shrink-0 text-body3-medium text-label-default'>설명 (선택)</p>
                <div className='relative'>
                  <input
                    {...register('description', {
                      maxLength: 20,
                    })}
                    className='input_sm min-w-[270px]'
                    placeholder='차시를 구분할 수 있는 설명을 작성해주세요'
                    type='text'
                    maxLength='20'
                  />
                  {watch('description') && (
                    <button
                      onClick={() => setValue('description', '')}
                      className='absolute right-8 top-8 cursor-pointer'
                    >
                      <CloseFilled />
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        {isValid ? (
          <button type='submit' className='button_solid_primary_sm gap-4 fill-inverse-label'>
            <CheckMark />
            <p>추가</p>
          </button>
        ) : (
          <button
            type='button'
            disabled
            className='button_outlined_disabled_sm gap-4 fill-label-disable'
          >
            <CheckMark />
            <p>추가</p>
          </button>
        )}
      </div>
    </form>
  )
}
